export const TIMETABLE_CONSTANTS = {
  HOMEROOMS: "HOMEROOMS",
  TEACHERS: "TEACHERS",
  ADMIN: "admin",
  DOWNLOAD_BUTTON: "DOWNLOAD_BUTTON",
  RADIO_BUTTON: "RADIO_BUTTON",
  UPLOAD_BUTTON: "UPLOAD_BUTTON",
  ERROR_MODAL: "ERROR_MODAL",
  VALIDITY_MODAL: "VALIDITY_MODAL",
  CONFIRM_TIMETABLE_IMPORT: "CONFIRM_TIMETABLE_IMPORT",
  ASC_FORMAT: "ascFormat",
  EDVAL_FORMAT: "edvalFormat",
  TFX_FORMAT: "tfxFormat",
  TODDLE_FORMAT: "toddleFormat",
  SYNC_WITH_SERVICE: "syncWithService",
  NO_ERROR: "NO_ERROR",
  CHECKLIST: "CHECKLIST",
  GENERAL_SETTINGS: "GENERAL_SETTINGS",
  PERIODS: "PERIODS",
  STUDENT_TIMETABLE: "STUDENT_TIMETABLE",
  TEACHER_TIMETABLE: "TEACHER_TIMETABLE",
  IMPORT_LOG: "IMPORT_LOG",
  DATA_MAPPING_TABLE: "DATA_MAPPING_TABLE",
  EDVAL_DATA_MAPPING_TABLE: "EDVAL_DATA_MAPPING_TABLE",
  ERROR_MODAL_V2: "ERROR_MODAL_V2",
  WARNING_MODAL: "WARNING_MODAL",
  SOFT_ERROR: "SOFT_ERROR",
  TTS_DATA_MAPPING_TABLE: "TTS_DATA_MAPPING_TABLE",
  STUDENT: "STUDENT",
  TEACHER: "TEACHER",
  CLASS: "CLASS",
};
